// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Ylr-","content":"styles_content__1PEho","checkbox":"styles_checkbox__P8Mtc","checkboxLabel":"styles_checkboxLabel__15iLZ"};